<template><!-- 前往下载 -->
    <el-dialog title="导出文件" :visible.sync="dialogSureExport" width="500px" :before-close="handleDialogClose">
    <div>
        <div class='tips-box'><span>可在后台管理-导出管理查看历史生成的导出文件</span></div>
        <div v-if="!status" style="text-align: center;padding: 10px 0;"><i class="el-icon-loading" style="font-size: 30px;"></i></div>
        <div v-else style="text-align: center;"><el-button size="small" type="primary" @click='goExport'>点击前往</el-button></div>
    </div>
    </el-dialog>
</template>
<script>
export default{
    name:'export-dialog',
    props:{
        status:{
           type: Boolean,
           default: () => false
        }
    },
    data(){
        return{
            dialogSureExport:true,
        }
    },
    methods: {
        goExport(){
            let routeUrl = this.$router.resolve({
                path: "/backstage",
                query: {to:'/backstage/exportmanage'}
            });
            window.open(routeUrl.href, '_blank');
        },
        handleDialogClose(){
            this.$emit("transData",false);
        }
    },
}
</script>
<style lang="scss" scoped>
/deep/.el-dialog__body{padding:2px 20px;}
.tips-box{
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 5px 8px;
    background-color: rgba(255, 118, 0, 0.1);
    border-radius: 3px;
    color: #ff7600;
    text-align: center;
    margin-bottom: 10px;
    span{
        display: inline-block;
        vertical-align: middle;
        width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color:rgb(32, 98, 231);
    }
}
</style>